<template>
  <div class="text-start">
    <!-- Proof before the pitch: the dish they were actually reaching for. -->
    <p v-if="personalMeal" class="mt-2 short:mt-0 text-[13px] italic leading-snug text-indigo-700 dark:text-indigo-300">
      {{ t('planner.locked_days_modal_personal', { meal: personalMeal }) }}
    </p>

    <ul class="space-y-1" :class="personalMeal ? 'mt-2.5' : 'mt-1'">
      <li
          v-for="benefit in benefits"
          :key="benefit"
          class="flex items-start gap-2 text-[13px] leading-snug text-gray-600 dark:text-gray-400"
      >
        <Check class="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-500" stroke-width="3"/>
        <span>{{ benefit }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Check } from 'lucide-vue-next'

/**
 * What Premium is for, said the same way wherever the offer appears.
 *
 * The two modals and the upgrade page each carried their own version of this,
 * which is how the generic trial modal ended up with no benefits at all while
 * the locked-day one had three. One component so they cannot drift again.
 *
 * Every line is a fact checked against what Premium actually gates: full-week
 * access and `replace-ai` with no quota. The AI coach is deliberately absent
 * because it carries a daily cap, and household sharing is absent because it
 * only holds for group members.
 */
defineProps({
  /** A real dish from the day they tried to open, when there is one. */
  personalMeal: { type: String, default: '' },
})

const { t } = useI18n()

const benefits = computed(() => [
  t('planner.upgrade_benefit_all_days'),
  t('planner.upgrade_benefit_swap'),
])
</script>
